/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* utilities */
import { parseDataToProps } from '../../utilities';

const searchNodes = Array.from(document.querySelectorAll('div[data-education-program]'));
if (searchNodes.length) {
    import(/* webpackChunkName: "EducationProgram" */ './components/EducationProgram').then(({ default: EducationProgram }) => {
        searchNodes.forEach((node) => createRoot(node).render(<EducationProgram {...parseDataToProps(node.dataset)}/>));
    });
}
